import React from 'react';

const Play = () => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.758 5.268c1.333.77 1.333 2.694 0 3.464l-7.137 4.12c-1.333.77-3-.192-3-1.732V2.88c0-1.54 1.667-2.502 3-1.732l7.137 4.12z"
      fill="currentColor"
    />
  </svg>
);

export default Play;
